

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./image.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 图片尺寸
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// devicePixelRatio
var DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;
// 是否是retina设备
var isRetinaDevice = DPR >= 2;
// 图片后缀正则
var REG_IMG_EXT = /.(jpg|png|gif|jpeg)/i;
// 图片url正则
var REG_IMG_SRC = /^(?:(?:http|https):)?\/\/(.+\.((?:upcdn|cdn))\.((?:pengpengla|upliveapp|upliveapps))\.(?:com))(\/.*(?:\.(jpg|png|gif|jpeg|webp))?)$/i;

var IMG_DEFAULT_SRC = '//g.cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png';

var IMG_PLACEHOLDE = "//g.cdn.pengpengla.com/oauthgame/html5/20181014/484a481c33c891be09c2a5c34bc08b2d.jpg";

// 海外CDN图片尺寸的大小列表
var IMG_SIZE_LIST = [50, 80, 100, 300, 600];

var isHttps = location.protocol === 'https:';

var Image = function (_Component) {
    _inherits(Image, _Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.state = {
            src: props.src,
            isVisible: typeof props.isVisible !== 'undefined' ? props.isVisible : true
        };
        return _this;
    }

    _createClass(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.isVisible) {
                return;
            }

            this.setState({
                src: nextProps.src,
                isVisible: nextProps.isVisible
            });
        }
    }, {
        key: 'px2rem',
        value: function px2rem(res) {
            var cssmode = this.props.cssmode;

            return res * 2 / (cssmode / 10) + 'rem';
        }
        /**
         * 输出转换后的图片url
         * @param {string} src 图片url
         */

    }, {
        key: 'getNewUrl',
        value: function getNewUrl(url) {
            var width = this.props.width || this.props.size;
            var height = this.props.height || this.props.size;
            var defaultSize = this.props.size || this.props.width;
            var newUrl = void 0;

            width = width * 2;
            height = height * 2;
            defaultSize = defaultSize * 2;

            url = url.replace('p-cdn.upliveapp.com', 'p.cdn.upliveapp.com');

            if (url.match(REG_IMG_SRC)) {

                var cdnSize = url.match(REG_IMG_SRC);

                if (this.props.type == 'square') {

                    if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
                        // 海外头像
                        var size = this.getBestCdnSize(defaultSize); // 头像 width == height
                        var exts = url.match(REG_IMG_EXT);

                        if (exts) {
                            var ext = '_' + size + '_' + size + exts[0];
                            newUrl = url.replace(REG_IMG_EXT, ext);
                        } else {
                            console.log('图片后缀名错误');
                        }
                    } else {
                        newUrl = this.state.src + (this.state.src.indexOf('?') > -1 ? '&' : '?') + 'imageView2/1/w/' + width + '/h/' + height;
                    }
                } else {
                    newUrl = this.state.src + (this.state.src.indexOf('?') > -1 ? '&' : '?') + 'imageView2/1/w/' + width + '/h/' + height;
                }
            } else {
                newUrl = url;
            }

            newUrl = newUrl.replace('http://p.cdn.upliveapp.com', 'https://p-cdn.upliveapp.com');
            newUrl = newUrl.replace('http://p.cdn.upliveapps.com', 'https://p-cdn.upliveapp.com');
            newUrl = newUrl.replace('http://p.upcdn.pengpengla.com', 'https://p.upcdn.pengpengla.com');

            return newUrl;
        }
        /**
         * 获取海外头像图片最佳尺寸
         * @param  {number| string} curSize 图片尺寸
         */

    }, {
        key: 'getBestCdnSize',
        value: function getBestCdnSize(curSize) {
            if (!curSize || typeof curSize != 'string' && typeof curSize != 'number') {
                console.log('未设置图片尺寸');
            }
            var sizeList = IMG_SIZE_LIST;
            var max = sizeList[sizeList.length - 1];
            var min = sizeList[0];
            var bestSize = 0;

            if (max <= curSize) {
                return max;
            }
            if (min >= curSize) {
                return min;
            }

            for (var i = sizeList.length; i >= 0; i--) {
                if (sizeList[i] <= curSize) {
                    if (sizeList[i] == curSize) {
                        bestSize = curSize;
                    } else {
                        if (i < sizeList.length - 1) {
                            // 取最近最优的尺寸
                            bestSize = sizeList[i + 1];
                        }
                    }
                    break;
                }
            }

            return bestSize;
        }
    }, {
        key: 'render',
        value: function render() {
            var width = this.props.width || this.props.size;
            var height = this.props.height || this.props.size;
            var cls = 'ui-img';
            var style = {};

            cls += this.props.bordered ? ' ui-bordered' : '';
            cls += this.props.circle ? ' ui-circle' : '';
            cls += this.props.rounded ? ' ui-rounded' : '';

            var props = void 0;

            style = {
                width: this.props.rem ? this.px2rem(width) : width,
                height: this.props.rem ? this.px2rem(height) : width
            };

            if (this.props.lazyload) {
                if (this.state.isVisible) {
                    props = {
                        src: this.state.src ? this.getNewUrl(this.state.src) : IMG_PLACEHOLDE
                    };

                    return _react2.default.createElement(
                        'span',
                        { className: cls, style: style, 'data-width': width, 'data-source': this.state.src, 'data-height': height },
                        _react2.default.createElement('img', _extends({ ref: 'img' }, props, { alt: '' }))
                    );
                } else {
                    props = {
                        'data-src': this.state.src ? this.getNewUrl(this.state.src) : '',
                        src: IMG_PLACEHOLDE
                    };

                    return _react2.default.createElement(
                        'span',
                        { className: cls, style: style, 'data-width': width, 'data-height': height },
                        _react2.default.createElement('img', _extends({ ref: 'img' }, props))
                    );
                }
            } else {
                props = {
                    src: this.state.src ? this.getNewUrl(this.state.src) : IMG_PLACEHOLDE
                };

                return _react2.default.createElement(
                    'span',
                    { className: cls, style: style, 'data-width': width, 'data-height': height },
                    _react2.default.createElement('img', _extends({ ref: 'img' }, props))
                );
            }
        }
    }]);

    return Image;
}(_react.Component);

Image.defaultProps = {
    src: '', // 图片地址
    cssmode: 640,
    type: 'square', // 图片类型，默认square: 正方形，custom: 裁剪称任意类型，只有七牛图片才支持
    size: '',
    width: '', // 图片宽度
    height: '', // 图片高度
    circle: false, // 圆形
    rounded: false, // 椭圆
    bordered: false,
    rem: true
};


module.exports = Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-ui/dist/Image.js
// module id = 343
// module chunks = 0 1